/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled from 'styled-components';
import { typography } from '@everlywell/leaves';

import Button from '../Button';
import { ariesTheme } from 'styles/ariesTheme';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-family: ${typography.type.nexa};
  position: relative;
  padding-top: 24px;
  margin: 0 4px 4px 0;
`;

const InputWrapper = styled.div`
  height: 48px;
  flex: 1;
`;

const Input = styled.input`
  font-family: inherit;
  border-radius: 3px;
  background-color: rgba(
    ${props => props.theme.primaryBgColor || ariesTheme.primaryBgColor},
    0.1
  );
  height: 48px;
  width: 100%;
  border-bottom: 2px solid
    rgb(${props => props.theme.primaryBgColor || ariesTheme.primaryBgColor});
  padding: 0 16px;
  outline: 0;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.11px;
  color: rgb(
    ${props => props.theme.tertiaryTextColor || ariesTheme.tertiaryTextColor}
  );

  border-top: none;
  border-right: none;
  border-left: 2px solid transparent;
  border-bottom: 2px solid
    rgb(${props => props.theme.primaryBgColor || ariesTheme.primaryBgColor});

  &::placeholder {
    font-size: 16px;
    opacity: 1;
    color: rgb(
      ${props =>
        props.theme.quaternaryTextColor || ariesTheme.quaternaryTextColor}
    );
  }

  &[data-is-empty='true'] {
    &::placeholder {
      font-style: italic;
      color: rgb(
        ${props =>
          props.theme.quaternaryTextColor || ariesTheme.quaternaryTextColor}
      );
    }
  }

  &:focus {
    background-color: rgba(
      ${props =>
        props.theme.primarySuccessColor || ariesTheme.primarySuccessColor},
      0.1
    );
    border-bottom-color: rgb(
      ${props =>
        props.theme.primarySuccessColor || ariesTheme.primarySuccessColor}
    );
    caret-color: rgb(
      ${props =>
        props.theme.primarySuccessColor || ariesTheme.primarySuccessColor}
    );
  }

  &[data-has-error='true'] {
    background-color: rgba(
      ${props => props.theme.badgeRedColor || ariesTheme.primaryDangerColor},
      0.1
    );
    border-bottom: 2px solid
      rgb(
        ${props => props.theme.badgeRedColor || ariesTheme.primaryDangerColor}
      );
    caret-color: rgb(
      ${props => props.theme.badgeRedColor || ariesTheme.primaryDangerColor}
    );
  }

  &:-moz-focusring {
    outline: none;
  }
`;

// TODO: main DLS Button component has no primary type border styles; add them
// to main Button component file in components/Button
const PromoButton = styled(Button)`
  width: 94px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 48px;
  margin-left: -2px;
  border: 1px solid
    rgb(${props => props.theme.primaryBgColor || ariesTheme.primaryBgColor});

  &:hover,
  &:active,
  &:focus {
    border: 1px solid
      rgb(
        ${props =>
          props.theme.primaryHoverBgColor || ariesTheme.primaryHoverBgColor}
      );
  }

  &:disabled {
    border: none;
    background-color: rgba(
      ${props =>
        props.theme.cartDisabledBtnColor || ariesTheme.cartDisabledBtnColor},
      0.9
    );
  }
`;

export { Wrapper, Input, InputWrapper, PromoButton };
